/** @description always include jQuery in this manner in every file where jQuery is used */
const $ = jQuery.noConflict();
let mult = false;
let prev = 0;
'use strict';
const SingleProduct = {
	/**
	 * @description Cache dom and strings
	 * @description Please always define selectors, classes and data attributes with the following prefixes
	 * @type {object}
	 * @param {jQuery} $dom	for any jQuery selectors
	 * @param {string} class for any class strings
	 * @param {string} attr for any data attributes strings
	 */

	$domSingleProductAccordion: $('.js-single-poduct__info-box-accordion'),
	classSingleProductAccordionActive: 'single-poduct__info-box-accordion--open',

	/**
	 * @description Initialize
	 * @example this.someFunction();
	 */
	init: function () {

		if (document.getElementById('singleGoBack')) {
			const singleGoBack = document.getElementById('singleGoBack');
			if (history && history.length > 1) {
				singleGoBack.addEventListener('click', () => {
					history.back(-1);
				});
			} else {
				singleGoBack.addEventListener('click', () => {
					window.location.replace(kadraGlobal.Url + '/shop');
				});
			}
		}

		$('.js-login-wrap').on('click', '.js-login-popup', function (ele) {
			const popup = document.getElementsByClassName('js-popup-login-form');
			popup[0].classList.add('active');
			popup[0].setAttribute('data-id', ele);
		});

		if (!$('body.post-type-archive-product').length) {
			$(document).ajaxStop(function () {
				SingleProduct.preventHold();
			});
			this.preventHold();
		}


	},

	preventHold() {
		$('.qty-input-custom').on('keyup', function () {
			const max = 5;
			let val = $(this).val();
			if (val.length >= max) {
				val = val.slice(0, max);
				$(this).val(val);
				$(this).attr('value', val);
			}
		});
	}
};

export default SingleProduct;
